module.exports = __webpack_public_path__ + "img/bank.9b91f310.svg";